<template>
    <!--顶部切换开始-->
    <div class="content-top-box clearfix" style="overflow:hidden;" @contextmenu.stop.prevent="">
        <div class="arrow-box arrow-box-left fl" :style="{display:tabCalc>scrollWidth?'block':'none'}" @click.stop="changeLeftFn">
            <img src="~@/assets/image/images/icons/icon_arrow_left.png" />
        </div>
        <div class="cut-normal fl" ref="scrollDom">
            <div class="right-top-tab cut-long120" :style="{width:`${tabCalc}px`,marginLeft:`${marginLeft}px`}">    
                <leftRightMenu :item="n" v-for="(n,i) in tabNav"
                    :key="i"  :index="i" ></leftRightMenu>
            </div>
        </div>
        <div class="arrow-box arrow-box-right fl" :style="{display:tabCalc>scrollWidth?'block':'none'}" @click.stop="changeRightFn">
            <img src="~@/assets/image/images/icons/icon_arrow_right.png" />
        </div>
        <div class="arrow-box arrow-box-right fr"  @click.stop="$emit('refresh');marginLeft=0">
            <img src="~@/assets/image/images/icons/icon_nav_return.png" />
        </div>
    </div>
    <!--顶部切换结束-->
</template>

<script>
import leftRightMenu from './leftRightMenu.vue';
export default {
    name:"topTab",
    components:{
      leftRightMenu
    },
    props:{
        tabNav:Array,
        showOrFalse:Boolean
    },
    data(){
        return{
            ids:[],
            speed:0,
            marginLeft:0,
            scrollWidth:0,
            //刚改的
            tabCalc:0
        }
    },
    mounted(){
        
        this.scrollWidth = this.$refs.scrollDom.clientWidth;
        this.initFloorDrag(this.tabNav);
    },
    watch:{
        //刚改的
        'tabNav':function(val){
            if(val){
                var twid = 0;
                val.filter((ite) => ite.name).forEach(element => {
                if (element.name) {
                    twid += ((element.name.length * 14) + (element.acquiesceType ? 20 : 0) + 45)
                }
                });
                this.tabCalc = twid; 
            }
        },
        '$store.state.winWidth':function(val){
          this.scrollWidth = this.$refs.scrollDom.clientWidth;
        },
        'showOrFalse':function(){
          this.scrollWidth = this.$refs.scrollDom.clientWidth;
          this.$emit('compute');
        }
    },
    computed: {

    },
    //跨级触发方法
    provide() {
        return {
        fatherMethod: this.tabSwitch,
        updateWidth: this.updateWidth,
        tabRight: this.tabRight
        }
    },
    methods:{
        initFloorDrag(val){
            var twid = 0;
            val.filter((ite) => ite.name).forEach(element => {
            if (element.name) {
                twid += ((element.name.length * 16) + (element.acquiesceType ? 20 : 0) + 45)
            }
            });
            this.tabCalc = twid; 
        },
        tabRight(item,ev){
            //右键搜索功能所需参数
            
        },
        updateWidth(t){
            //接受下级新增宽度或减少宽度
            this.tabCalc += t;
        },
        changeLeftFn(){
            if(this.speed == 0){
                return false;
            }
            this.speed++;
            this.marginLeft = this.speed * 150;
        },
        changeRightFn(){
            if(this.tabCalc + this.marginLeft < this.scrollWidth){
                return false;
            }
            this.speed--;
            this.marginLeft = this.speed * 150;
        },
        tabSwitch(item){
            this.$emit('changeCon',item.id);
        }
    }
}
</script>

<style lang="scss" scoped>
.arrow-box {
    width: 24px;height: 52px;text-align: center;line-height: 52px;cursor: pointer;margin-left: 12px;
    &:hover{background-color: #fafafa;}
    img{vertical-align: middle;width: 14px !important;height: 14px !important;}
}
.content-top-box {
    border-bottom: 1px solid #dddddd;
    height: 52px;
    width: 100%!important;
    min-height: 52px;
    .cut-normal {
    width: calc(100% - 118px);
    overflow: hidden;
    margin-left: 10px;
    }
    .right-top-tab {
    overflow: hidden;
    height: 52px;
    margin-top: 1px;
    transition: .3s all;
    .right-tab {
        position: relative;
        cursor: pointer;
        display: inline-block;
        height: 60px;
        line-height: 61px;
        margin: 0 20px;
        font-size: 16px;
        &:hover {
            color: #0d78cf;
        }
        .first {
        position: absolute;
        right: -18px;
        top: 18px;
        background-color: #f30101;
        color: #ffffff;
        font-weight: bold;
        height: 12px;
        line-height: 12px;
        border-radius: 4px;
        padding: 1px 3px;
        font-size: 12px;
        }
    }
    .right-tab.curr {
        position: relative;
        border-bottom: 1px solid #0d78cf;
        color: #0d78cf;
    }
    .right-tab.color-blue {
        color: #0d78cf;
    }
    .right-tab.main {
        font-weight: bold;
        color: #0d78cf;
    }
    .right-tab.main.curr {
        font-weight: bold;
    }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/leftRightSlide.vue